import { createSelector } from '@reduxjs/toolkit';

import { AppState } from '@/redux/helper';
import { selectIsFreeUser } from '@/redux/selectors/users';

// eslint-disable-next-line import/prefer-default-export
export const selectShouldPlayAdvertisement = createSelector(
  [
    (state: AppState) => state.user.logged,
    selectIsFreeUser,
    (state: AppState) => state.settings.advertisements.shouldShowAd,
  ],
  (logged, isFreeUser, shouldShowAd) => {
    if (!logged) {
      return shouldShowAd;
    }
    if (!isFreeUser) {
      return false;
    }
    return shouldShowAd;
  },
);
